<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="390">
            <v-card>
                <v-toolbar color="primary" >
                    <v-toolbar-title>Editar Perfil</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                    <v-form ref="formDialog" >
                        <v-container class="smslim">
                            <v-row class="pt-2">
                                <v-col cols="12" sm="6">
                                    <v-text-field class="pr-2 mx-240"
                                                  v-model="user.fldTNombre"
                                                  label="Nombre"
                                                  outlined
                                                  :rules="nameRules"
                                                  dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field class="mx-240"
                                                  v-model="user.fldTLogin"
                                                  label="Usuario"
                                                  outlined
                                                  :rules="loginRules"
                                                  dense></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field class="mx-240"
                                                  v-model="user.fldTEmail"
                                                  label="Email *"
                                                  :rules="emailRules"
                                                  outlined
                                                  dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field outlined
                                                  dense
                                                  label="Password*"
                                                  type="password"
                                                  :rules="passwordRules"
                                                  v-model="user.fldTPassword"></v-text-field>
                                </v-col>
                            </v-row>

                        </v-container>
                        <small>*indica campos requeridos</small>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="saveData" >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { Component, Prop, Vue } from "vue-property-decorator";
    import UserModel from "@/models/UserModel";
    import UserService from "@/services/UserService";

    @Component({
        methods: {
            showDialog: async function () {
                var self = this;
                var data = await new UserService().get(self.$auth.user().id);
                this.$data.user = data.data;
                this.$data.dialog = true;
                return new Promise(function (resolve, reject) {
                    self.resolve = resolve;
                });
            },
            saveData: async function () {
                try {
                    if (!this.$refs.formDialog.validate()) {
                        return;
                    }

                    var uService = new UserService();
                    var data = null;
                    if (this.$data.user.idNUsuario) {
                        data = await uService.update(this.$data.user);
                    } else {
                        data = await uService.insert(this.$data.user);
                    }
                    if (data.success) {
                        this.$data.dialog = false;
                        this.loadData();
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro');
                    }
                } catch (e) {
                    console.log(e);
                }
            },
        },
        created: function () {
            this.$store.watch(state => state.showProfileDialog, () => {
                const show = this.$store.state.showProfileDialog;
                if (show) {
                    this.showDialog();
                    this.$store.commit('showProfile', null)
                }
            });
        }
    })
    export default class EditProfile extends Vue {
        dialog = false;
        user = new UserModel();
        id = '';

        nameRules = [
            v => !!v || 'Debe ingresar un nombre',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];
        loginRules = [
            v => !!v || 'Debe ingresar un usuario',
            v => v && v.length <= 250 || 'El usuario tiene que contener menos de 250 caracteres',
        ];
        emailRules = [
            v => !!v || 'Debe ingresar un email',
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email ingresado es incorrecto'
        ];
        passwordRules = [
            v => !!v || 'Debe ingresar una contrase�a',
            v => v && v.length <= 250 || 'La contrase�a tiene que contener menos de 250 caracteres',
        ];

    }

</script>

